import React, { useEffect, useState } from 'react'
import newsService from '../../../services/news.service';
import { BaseURL } from '../../../constants/enum/baseURL.emum';

function ListNews() {
  const [listNew, setListNew] = useState([]);

  useEffect(() => {
    (async () => {
      await newsService.getAll().then((res) => {
        // console.log(res.data.data);
        setListNew(res.data);
      });
    })();
  }, []);
  return (
    <>
      <div className="row">
        <div className="col">
          <div className="container mt-3 mb-4">
            <div className="col mt-4 mt-lg-0">
              <div className="row">
                <div className="col-md-12">
                  <div className="user-dashboard-info-box table-responsive mb-0 bg-white p-4 shadow-sm">
                    <table className="table manage-candidates-top mb-0">
                      <thead>
                        <tr>
                          <th>
                            <h4>
                              <strong>รายการข่าวประชาสัมพันธ์</strong>
                            </h4>
                          </th>
                          {/* <th className="text-center">
                            <h4>
                              <strong>สถานะ</strong>
                            </h4>
                          </th> */}
                          <th className="action text-right">

                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {listNew.map((itemNews: any) => {
                          return (
                            <tr className="candidates-list" key={itemNews.id}>
                              <td className="title">
                                <div className="thumb">
                                  <img
                                    className="img-fluid"
                                    src={`${BaseURL.BASE_URL}/upload/news/${itemNews.image}`}
                                    alt="ภาพข่าว"
                                  />
                                </div>
                                <div className="candidate-list-details">
                                  <div className="candidate-list-info">
                                    <div className="candidate-list-title">
                                      <h5 className="mb-0">
                                        {itemNews.url ? (
                                          <a
                                            href={itemNews.url}
                                            target="_blank"
                                            rel="noreferrer"
                                          >
                                            {itemNews.title}
                                          </a>
                                        ) : (
                                          itemNews.title
                                        )}
                                      </h5>
                                    </div>
                                    <div className="candidate-list-option">
                                      <ul className="list-unstyled">
                                        <li>{itemNews.discription}</li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </td>
                              {/* <td>{itemNews.status}</td> */}
                              <td>

                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ListNews